var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_html.js
// module id = 579
// module chunks = 0